module.exports = __webpack_public_path__ + "static/media/tyre-yellow-three2.30a61af6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-three2.png
// module id = 353
// module chunks = 0